/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import { useTheme } from '../utils/index.js';
/**
 * TagContainer for grouping tags.
 * @example
 * <TagContainer><Tag>Tag 1</Tag><Tag>Tag 2</Tag></TagContainer>
 * <TagContainer><Tag variant='basic'>Basic tag</Tag><Tag variant='basic'>Basic tag 2</Tag></TagContainer>
 */
export const TagContainer = (props) => {
    const { className, children, overflow, background = 'none', ...rest } = props;
    useTheme();
    return (React.createElement("div", { className: cx('iui-tag-container', {
            [`iui-${overflow}`]: !!overflow,
            'iui-visible': background !== 'none',
        }, className), ...rest }, children));
};
export default TagContainer;
